import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import queryString from 'query-string';

import {
  receiveRSSFeedError,
  submitRSSFeed,
  receiveRSSSearch,
  receiveRSSFeedMetadata,
} from '../../../../onboarding';

import { ImportSection as ImportSectionView } from './ImportSection';

// Redux ------------------------------------------------

const mapDispatchToProps = dispatch => ({
  onTypeaheadSearch: value => {
    dispatch(receiveRSSSearch(value));
  },
  onSelectTypeahead: (option, t) => {
    if (option[0]) {
      const rssMetadata = option[0];
      const rssFeedUrl = rssMetadata.feedUrl;
      if (rssFeedUrl && rssMetadata.podcastName) {
        if (rssFeedUrl.startsWith('https://anchor.fm/')) {
          // User is importing an anchor account
          // TODO (bui): a cta here? server check?
          const title = rssMetadata.podcastName;
          dispatch(
            receiveRSSFeedError({
              message: t(
                'ImportScreen.ImportSection.PodcastAlreadyImportedErrorMessage',
                '{podcastName} is already on Anchor! Just login to access this podcast.',
                'Switch podcast to Anchor error when the podcast is already imported',
                { podcastName: title }
              ),
            })
          );
        } else {
          dispatch(submitRSSFeed(rssFeedUrl));
        }
      } else {
        dispatch(
          receiveRSSFeedError({
            message: t(
              'ImportScreen.ImportSection.ExtractFeedErrorMessage',
              'Sorry, we were unable to extract an RSS feed from this result.',
              'Switch podcast to Anchor error message when reading the RSS feed'
            ),
          })
        );
      }
    } else {
      // Clear any possible metadata
      dispatch(receiveRSSFeedMetadata({}));
    }
  },
  onBlur: feedUrl => {
    dispatch(submitRSSFeed(feedUrl));
  },
  onSubmit: partnerName => {
    const switchQuery = partnerName
      ? {
          partner: partnerName,
        }
      : {};
    const switchUrl = queryString.stringifyUrl({
      url: `/switch/signup`,
      query: switchQuery,
    });
    dispatch(push(switchUrl));
  },
});
const mapStateToProps = ({
  onboarding: {
    fetchingRSSFeedImport,
    rssFeed,
    rssFeedIsValid,
    rssFeedError,
    rssFeedMetadata,
  },
  search,
}) => ({
  enableReinitialize: true,
  initialValues: {
    rssFeedUrl: rssFeed,
  },
  fetchingRSSFeedImport,
  rssFeedUrl: rssFeed,
  rssFeedIsValid,
  rssFeedError,
  rssFeedMetadata,
  isSearching: search.isSearchingRssTypeaheadResults,
  rssTypeaheadResults: search.rssTypeaheadResults,
});

export const ImportSection = connect(
  mapStateToProps,
  mapDispatchToProps
)(ImportSectionView);
